import axios from 'axios';
import { fromCatalogDto } from '../../mappers/catalogs/toCatalogModel';
import { CatalogModel } from './types';

export const getCatalog = async (catalogId: string): Promise<CatalogModel> => {
    const response = await axios.get(`/catalogs/${catalogId}`);

    return fromCatalogDto(response.data.catalog);
};
